<template>
  <div class="game-text-block-with-input" :style="getMainStyle(startGameConfig)">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div v-if="!checkKatexMarker(textBlock)" class="text-block" :style="getStyle()" v-html="textBlock"></div>
    <div v-if="checkKatexMarker(textBlock)" class="text-block" :style="getStyle()">
      <ps-text :font-size="isKatexFontSize" :text-value="textBlock" v-if="isKatexFontSize"></ps-text>
      <ps-text :text-value="textBlock" v-else></ps-text>
    </div>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      class="box-style"
      :style="getBoxStyle(boxConfig)"
    ></tr-box>
    <div
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
      v-html="item.text"
    ></div>
  </div>
</template>

<script>
/**
 * @namespace TextBlockWithInput
 */
/**
 * Obiekt konfiguracji inputa
 * @typedef ItemConfig
 * @memberof TextBlockWithInput
 *
 * @property {MainImage}  mainImage - konfogurowalne tło
 * @property {BoxConfig}  boxConfig - konfiguracja ramki z wyrazami
 * @property {Number} MAGIC_PROPERTY-  skala szerokosci dla inputow. Bierze najdłuższy wyraz z poprawnych odpowiedzi i za pomocą tej skali określa szerokośc inputów
 * @property {Number} padding - określenie paddingu dla tekstu
 * @property {Number} marginTop - maergines od góry
 * @property {Number} text - blok tekstu z miejscami na inputa. Miejsca na inputa oznaczamy \{\{ POPRAWNA_WARTOŚĆ1, POPRAWNA_WARTOŚĆ2,itd. \}\}. Jeśli konieczne jest użycie przecinka należy zastosować \{\{ 0&,04, 0&,12,itd. \}\}
 *
 * @tutorial textBlockWithInput1
 * @example
 * (...)
 *  {
 *    mainImage: {
 *      imagePath: 'games/page012_game1/img/bcg.jpg',
 *      width: 1920,
 *      height: 1080,
 *      position: 'absolute',
 *      pos: {
 *        x: 0,
 *        y: 0,
 *      },
 *    },
 *    MAGIC_PROPERTY: 0.5,
 *    padding: 1,
 *    marginTop: 13,
 *    text:
 *      'Odpowiedź: Masa chlorowodoru, podana z dokładnością do pierwszej liczby po przecinku wynosi {{36&,5}} g. <br />\
 *      Stężenie procentowe sporządzonego roztworu, podane z&nbsp;dokładnością do jedności wynosi {{10}}%.',
 *    cssStyle: {
 *      width: '960px',
 *      position: 'absolute',
 *      top: '140px',
 *      left: '480px',
 *      fontSize: '39px',
 *    },
 *  },
 * (...)
 */

/**
 * Konfiguracja gier opartych na silniku TextBlockWithInput
 * @typedef TextBlockWithInputConfig
 *
 * @property {MainImage}  mainImage - konfogurowalne tło
 * @property {Array.<Pos>} layoutItems - tablica położeń dla inputów
 * @property {Array.<Pos>} layoutImages- tablica położeń dla obrazków
 * @property {Boolean}  shuffle - czy tablica **items** ma się losować
 * @property {Number}  pick  - ilość elementów do wybrania
 * @property {Object} cssStyle - indywidualny styl CSS, którym można zmienić wygląd elementu (w tym wypadku c)
 * @property {Array.<TextBlockWithInput.ItemConfig>} items - tablica konfigurowanych inputów jeśli wewnątrz jest kolejna tablica items
 */

/**
 * Konfiguracja gier opartych na silniku inputOnBackground
 * @type {TextBlockWithInputConfig}
 * @memberof TextBlockWithInput
 * @name TextBlockWithInputConfig
 */
var config;

// HACK: Przepisać komponent bo mix z jQuery teraz jest
import _ from 'lodash';
import $ from 'jquery';
import defaultMixin from '../../mixins/defaultMixin';
import * as utils from '../../Utils/inputUtils';
import TrBox from '../../GameBaseElements/TrBox/TrBox';
import PsText from '../TrInput/PsText';
export default {
  name: 'tr-text-block-with-input',
  components: { TrBox, PsText },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin],
  data() {
    return {
      katexFontSize: this.startGameConfig.katexFontSize,
      staticText: [],
      textBlock: '',
      imageData: {},
      MAGIC_PROPERTY: '',
      words: [],
      boxConfig: {},
      inputStyle: {},
    };
  },
  beforeCreate() {},
  created() {
    /** @type {String} prasing text with placeholder {{placeholder}} */
    this.data = this.prepareBlockData(this.startGameConfig);
    this.MAGIC_PROPERTY = _.cloneDeep(this.data.MAGIC_PROPERTY || 0.75);
    (this.words = _.shuffle(_.cloneDeep(this.data.words))), (this.textBlock = this.data.text);
    this.textBlock = this.stringParser(this.textBlock);
    this.boxConfig = {
      x: (this.data.boxConfig && this.data.boxConfig.left) || 1,
      y: (this.data.boxConfig && this.data.boxConfig.top) || 14,
      width: (this.data.boxConfig && this.data.boxConfig.width) || 98,
      height: (this.data.boxConfig && this.data.boxConfig.height) || 12,
      unit: '%',
      cssStyle: this.data.boxConfig && this.data.boxConfig.cssStyle,
      wordConfig: (this.data.boxConfig && this.data.boxConfig.wordConfig) || {},
      delimiter: (this.data.boxConfig && this.data.boxConfig.delimiter) || {},
    };
    this.inputStyle = {
      italic: (this.data.inputStyle && this.data.inputStyle.italic) || false,
      correctIndex: (this.data.inputStyle && this.data.inputStyle.correctIndex) || 0,
    };
    console.log(this.data);
    if (this.data.mainImage) {
      this.imageData = this.data.mainImage;
    } else if (this.data.background) {
      this.imageData = Object.assign({}, { imagePath: this.data.background });
    }
    /** add static text */
    if (this.startGameConfig.staticText) {
      if (
        this.startGameConfig.staticText[0] &&
        this.startGameConfig.staticText[0].items &&
        this.startGameConfig.staticText[0].items.length > 0
      ) {
        if (this.startGameConfig.staticText[0].pick) {
          this.staticText = _.map(this.startGameConfig.staticText, (elem) => {
            return _.take(_.cloneDeep(elem.items), elem.pick);
          });
          this.staticText = _.flatten(staticText);
          // staticText.push(_.sampleSize(_.cloneDeep(staticText[0].items), staticText[0].pick));
        }
      }
      this.staticText = this.startGameConfig.staticText;
    }
    if (this.staticText.length > 0) {
      this.staticText = _.map(this.staticText, (item, index) => {
        if (this.startGameConfig.layoutStaticText) {
          return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
        } else {
          return item;
        }
      });
    }
  },
  beforeMount() {},
  mounted() {
    //**max number of char in input round(the longest word + 20% )
    let self = this;
    $('.inline-input').each(function (item) {
      $(this).attr('maxlength', String(_.round(self.maxLength * 1.2)));
    });
    /**
     * removing error class on focus
     * @method
     */
    $('.inline-input').focus(function () {
      $(this).removeClass('inline-input-wrong');
      self.resetCheckStatus();
    });
  },
  methods: {
    checkKatexMarker(item) {
      let flag = item.search('_#');
      if (flag == -1) {
        return false;
      }
      return true;
    },
    processData(node, staticText, imageArray, parentNode) {
      if (node.items) {
        // if(status.length>0){}
        if (node.pick && node.shuffle) {
          node.items = _.sampleSize(_.cloneDeep(node.items), node.pick);
        } else if (node.pick) {
          node.items = _.take(_.cloneDeep(node.items), node.pick);
        }
        if (node.shuffle) {
          node.items = _.shuffle(node.items);
        }
        if (node.staticText) {
          staticText.push(node.staticText);
        }
        if (node.imageData) {
          imageArray.push(node.imageData);
        }
        return _.flattenDeep(
          _.map(node.items, (item) => {
            return this.processData(item, staticText, imageArray, node);
          })
        );
      }
      // let status = _.filter(node.items, 'staticIndex');
      if (node.staticText) {
        staticText.push(node.staticText);
      }
      if (node.imageData) {
        imageArray.push(node.imageData);
      }
      return node;
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getBoxStyle(box) {
      // box.x = box.x;
      // box.y = box.y;
      // box.width = box.width;
      // box.height = box.height;
      return _.merge({}, this.getCustomStyle(box));
    },
    prepareBlockData(data) {
      if (data.pick && data.items) {
        let items = data.shuffle ? _.shuffle(_.cloneDeep(data.items)) : _.cloneDeep(data.items);
        let preparedData = _.sampleSize(items, data.pick);
        if (_.isArray(preparedData)) {
          preparedData = preparedData[0];
        }
        return preparedData;
      } else {
        return _.cloneDeep(data);
      }
    },
    /**
     * parsing text - replace markers by input with id and data-key
     * @method stringParser
     * @param  {String}     text text with placeholder
     * @return {String}          text with HTML input tag
     */
    stringParser(text) {
      let regExp = /{{(.+?)}}/g;
      let test = text.match(regExp);
      let elements = _.map(test, (item, index) => {
        let rowItem = _.clone(item);
        let italic = /#i#/.test(item);
        item = item.replace(/#i#/, '');
        let rowWords = item.replace(/({{)|(}})/g, '');
        let allWords = rowWords.split('/');
        return {
          allWords,
          textToReplace: rowItem,
          index,
          italic,
        };
      });
      /**
       * max number of  leter in words
       * @type {String}
       */
      this.maxLength = _.max(
        _.flattenDeep(
          _.map(elements, (item) => {
            if (_.isArray(item.allWords)) {
              return _.map(item.allWords, (innerElem) => {
                return innerElem.length;
              });
            } else {
              return item.allWords.length;
            }
          })
        )
      );
      /**
       * replace placeholder
       * @type {Array}
       */
      _.each(elements, (item, index) => {
        // TODO:wymienić na element używający componetów
        // TODO:max liczba znakow
        let textStyle = this.inputStyle.italic ? 'font-style: italic;' : '';
        if (item.italic) {
          textStyle = 'font-style: italic;';
        }
        if (this.data.input) {
          let customTextStyle = this.getCustomStyle(this.data.input);
          let customTextStyleString = '';
          _.each(customTextStyle, (value, key) => {
            customTextStyleString += [String(key), ':', String(value), ';'].join('');
          });
          textStyle = [textStyle, customTextStyleString].join('');
        }
        let data = [
          'width',
          ':',
          _.round(this.maxLength * this.MAGIC_PROPERTY, 2),
          'em',
          ';',
          'height: 1.5em;',
          textStyle,
        ].join('');
        text = text.replace(
          item.textToReplace,
          `<input autocomplete="off" id="input_${index}" style="${data}" data-correct-word="${item.allWords}" class="inline-input"/>`
        );
        // text = text.replace(item.textToReplace, ` <tr-input style="${data}" class="inline-input"></tr-input>`);
        // text = text.replace(item.textToReplace, ` <span style="color:red;">TEST</span>`);
      });
      return text;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      // _.each( this.selected, ( item, key, collection ) => {
      //   collection[ key ] = "";
      // } );
      this.resetCheckStatus();
      this.words = _.shuffle(_.cloneDeep(this.data.words));
      let data = document.getElementsByClassName('inline-input');
      _.each(data, (item, index) => {
        $(item).val((index, itemValue) => {
          return '';
        });
        $(item).prop('disabled', false);
        $(item).removeClass('inline-input-correct');
        $(item).removeClass('inline-input-wrong');
        $(item).removeClass('inline-input-disabled');
      });
    },
    checkGameAction() {
      let data = document.getElementsByClassName('inline-input');
      let status = _.reduce(
        data,
        (result, value, key) => {
          let temVal = null;
          $(value).val((index, itemValue) => {
            return _.trim(itemValue);
          });
          let tVal = $(value).val();
          let allWords = $(value).attr('data-correct-word');
          console.log('allWords- data-correct-word', allWords);
          // allWords = $(allWords).replaceAll(/&,/g, '&&').split(',');
          if (_.isArray(allWords)) {
            allWords = allWords.map((o) => o.replace(/&,/g, '&&')).map((o) => o.split(','));
          } else {
            allWords = allWords.replace(/&,/g, '&&').split(',');
          }
          allWords = allWords.map((o) => o.replace(/&&/g, ','));
          let index = _.findIndex(allWords, (o) => {
            return o === tVal;
          });
          if (index != -1) {
            temVal = result && true;
            $(value).removeClass('inline-input-wrong');
            $(value).prop('disabled', true);
            $(value).addClass('inline-input-disabled');
            $(value).addClass('inline-input-correct');
            if (this.data.replaceAfterCorrect) {
              $(value).val((index, itemValue) => {
                return allWords[this.inputStyle.correctIndex] ? allWords[this.inputStyle.correctIndex] : allWords[0];
              });
            }
          } else {
            temVal = false;
            $(value).addClass('inline-input-wrong');
            let blink = function (duration = 0) {
              return new Promise((resolve, reject) => {
                $(value).addClass('inline-input-wrong');
                setTimeout(resolve, duration);
              });
            };
            blink(1000).then(() => {
              $(value).removeClass('inline-input-wrong');
              $(value).val((index, itemValue) => {
                return '';
              });
            });
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(data, (item, key) => {
          console.log('item', $(item).val());
        });
      }
      return status;
    },
    onKeyDown(evt) {
      // console.log( 'onKeyDown' );
      if (this.value.length >= this.max) {
        if (evt.keyCode >= 48 && evt.keyCode <= 90) {
          evt.preventDefault();
          return;
        }
      }
    },
    getMainStyle(item) {
      let width = '1920px';
      let height = '1080px';
      if (item && item.cssStyle) {
        (width = item.cssStyle.width || width), (height = item.cssStyle.height || height);
      }
      return _.merge({}, { width: width, height: height }, this.getCustomStyle(item));
    },
    getStyle() {
      // padding: 5%;
      // margin-top: 12%;
      return _.assign(this.getCustomStyle(this.data), {
        padding: this.data.padding + '%',
        'margin-top': this.data.marginTop + '%',
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
      // return {
      //   'width': (item.textBlockWidth) ? utils.elementWidth(item.textBlockWidth) : utils.elementWidth(this.data.textBlockWidth),
      //   'height': (item.textBlockHeight) ? utils.elementHeight(item.textBlockHeight) : utils.elementHeight(this.data.textBlockHeight),
      //   'justify-content': (item.flexJustify) ? 'center' : item.flexJustify,
      // };
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.position) {
          imageData = Object.assign({}, imageData, {
            position: '',
          });
        }
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }

      return {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        position: imageData.position,
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      };
    },
  },
  computed: {
    boxConfigFontSize() {
      let fontSize = this.data.boxConfig && this.data.boxConfig.fontSize;
      return fontSize + 'px';
    },
    // fontSizeWithoutPx() {
    //   let fontsize = 28;
    //   if (this.data?.cssStyle?.fontSize) {
    //     fontsize = this.data.cssStyle.fontSize.substring(0, this.data.cssStyle.fontSize.length - 2);
    //   }
    //   return fontsize;
    // },
    isKatexFontSize() {
      if (this.katexFontSize) {
        return this.katexFontSize;
      } else {
        return null;
      }
    },
  },
};
</script>
<!-- HACK: nie da sie zastosować  stylu o ograniczonym zasiegu -->
<style lang="scss">
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';
@import '~@/assets/sass/textBlockWithInput';
</style>
<style lang="scss" scoped>
.game-text-block-with-input {
  overflow: hidden;
  height: 100%;
  .main-image-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .text-block {
    overflow-y: auto;
  }
}
</style>
